import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { egretAnimations } from "../../../shared/animations/egret-animations";
import { ColumnDefinition, EditableFieldChangeEvent, ExtraButtonEvent, ExtraButtons, MatrixCheckboxEvent  } from 'app/models';
import { UntypedFormBuilder, FormControl, UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-matrix-ngx-table',
  templateUrl: './matrix-ngx-table.component.html',
  styleUrls: ['./matrix-ngx-table.component.scss'],
  styles: ['table {width: 100%; }'],
  animations: egretAnimations
})
export class MatrixNgxTableComponent implements OnInit {

  // inputs
  @Input() showLoader = false;
  @Input() items: [] = [];
  @Input() columnDefinition: ColumnDefinition[] = [];
  @Input() addBtnName: string = null;
  @Input() deleteButton: boolean = false;
  @Input() translatePrefix: string = "";
  @Input() totalElements: number = 0;
  @Input() enableMatrixEdit: boolean = false;
  @Input() viewButton: boolean = false;
  @Input() editButton: boolean = false;
  @Input() inputFooter: boolean = false;
  @Input() selectionFields: Map<string, any[]> = new Map();
  @Input() numPage: number = 1;
  @Input() transposedMatrix: boolean = false;

  @Input() extraButtons: ExtraButtons[] = [];

  //outputs
  @Output() openPopup = new EventEmitter();
  @Output() delete = new EventEmitter();
  @Output() view = new EventEmitter();
  @Output() add = new EventEmitter();
  @Output() matrixCheckbox = new EventEmitter<MatrixCheckboxEvent>();
  @Output() editableFieldChange = new EventEmitter<EditableFieldChangeEvent>();

  @Output() extraBtn = new EventEmitter<ExtraButtonEvent>();
  dataRows: any = [];
  columnNames: string[] = [];
  addForm: UntypedFormGroup;

  constructor(private fb: UntypedFormBuilder, private translateService: TranslateService) {
    this.addForm = this.fb.group({});
  }

  ngOnInit() {
    this.columnNames = this.columnDefinition.map(x => x.columnName);
    this.columnNames.push("actions");
   
  }

  editableValueChanged(columnName: string, row: any, value) {
    this.editableFieldChange.emit({row: row, columnName: columnName, changeValue: value})

  }

  ngAfterViewInit() {        
    // reset the paginator after sorting

}


  openPopUp(data: any = {}) {
    this.openPopup.emit(data);
  }

  deleteItem(row) {
    this.delete.emit(row);
  }

  viewItem(row) {
    this.view.emit(row);
  }

  //This shouldn't be part of table component since it is reusable component, but it was too late. 
  selectionChanged(event) {
    if (event.value === 'Online') {
      this.addForm.controls['extSystemId'].enable();
    }
    else {
      this.addForm.controls['extSystemId'].patchValue('');
      this.addForm.controls['extSystemId'].disable();
    }
  }

  addItem() {
    this.add.emit(this.addForm.value);
    if (this.inputFooter) {
      this.columnDefinition.forEach(column => {
        this.addForm.controls[column.columnName].patchValue('');
        this.addForm.controls[column.columnName].markAsUntouched();
      })
    }
    this.addForm.reset();
  }

  matrixCheckboxChanged(rowIndex: number, columnName: string, event) {
    this.matrixCheckbox.emit({rowIndex: rowIndex, columnName: columnName, changeValue: event.checked})
  }


  extraBtnClick(row, btnAction) {
    this.extraBtn.emit({
      data: row,
      btnAction: btnAction
    });
  }
}
